import React from 'react';
import { Table, message, Tooltip,Input } from 'antd';
import { findGuestGroups } from "../../services/evt";
import Holder from "../../components/Holder";
const { Search } = Input;
class GuestLibrarySelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formLoading: false,
            loading: true,
            selectedRowKeys: [],
            selectedRows: [],
            data: [],
            columns: [
                {
                    title: '头像',
                    dataIndex: 'avatarUrl',
                    width: 220,
                    fixed: false,
                    render: (text, record, index) => (
                        <div className="ant-row-flex">
                            <div className="col-flex-primary" style={{ flexGrow: 0, marginRight: 7 }}>
                                <Holder
                                    src={text}
                                    width={60}
                                    height={60}
                                    size={18}
                                    text={`1`}
                                />
                            </div>
                            <div className="col-flex-primary">
                                <div className="mdc-text-grey table-font-small">{record.name}</div>
                            </div>
                        </div>
                    ),
                },

                {
                    title: '简介', dataIndex: 'introduction', render: (text, record, index) => (
                        <div>
                            <Tooltip title={text}>
                                {text}
                            </Tooltip>
                        </div>
                    )
                },
            ]

        }
    }

    componentDidMount() {
        this.mounted = true;
        this.fetchData()
    }

    componentWillUnmount() {

    }


    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys, selectedRows });
        this.props.onChangeSelect(selectedRowKeys, selectedRows);
    }

    fetchData = (name='') => {
        this.setState({
            loading: true
        })
        findGuestGroups({name:name,userId:this.props.userId, page: 1, pageSize: 100 }).then(res => {
            if (res.code == 200) {
                this.setState({
                    data: res.data,
                    loading: false
                })
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })
    }



    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading
            })
        }
    }



    render() {
        let { data, columns, loading, selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        }
        const ckDataTableToolbarLeft =
            <div>
                <div className="search-bar">
                    <Search
                        size="large"
                        placeholder={`请输入嘉宾名称`}
                        onSearch={value => {
                             this.fetchData(value);
                        }}
                    />
                </div>
            </div>



        return (

            <Table
                style={{marginTop:-16}}
                title={()=>ckDataTableToolbarLeft}
                pagination={false}
                loading={loading}
                rowKey={record => record.id}
                rowSelection={rowSelection}
                columns={columns}
                dataSource={data}
                scroll={{ x: 701, y: 'calc(100vh - 375px)' }}
            />

        )
    }
}


GuestLibrarySelect.contextTypes = {}

GuestLibrarySelect.defaultProps = {
    userId:'',
    onChangeSelect: (rowKeys, rows) => null,
}

GuestLibrarySelect.propTypes = {}


export default GuestLibrarySelect;


// WEBPACK FOOTER //
// ./src/containers/GuestLibrary/GuestLibrarySelect.jsx